// extracted by mini-css-extract-plugin
export var actions = "_ah-8";
export var arrow = "_ah-5";
export var card = "_ah-0";
export var cardWrapper = "_ah-9";
export var fieldName = "_ah-3";
export var newValue = "_ah-6";
export var oldValue = "_ah-4";
export var orangeGlowFade = "_ah-c";
export var productSection = "_ah-1";
export var scrollToBottom = "_ah-b";
export var scrollToBottomAnchor = "_ah-a";
export var scrollToBottomIcon = "_ah-d";
export var showAllButton = "_ah-7";
export var table = "_ah-2";